import Vue from 'vue'
import SvgIcon from '@/components/common/svgIcon'

//Brother when you see this code, I have resigned, you resign, hurriedly resign, hurriedly resign, this company is a pit, all kinds of pits, what benefits are not, the construction period desperately pressure, overtime without overtime pay no vacation

Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
